module.exports = __webpack_public_path__ + "static/img/0201_02.a5224c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/02/0201_02.jpg
// module id = fpQE
// module chunks = 1